import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { CartContext } from '../context/CartContext';
import './ProductDetails.css';

const ProductDetails = ({ show, handleClose, product, vendorName, logoUrl, vendorId }) => {
  const { addToCart, cartItems } = useContext(CartContext);
  const [localQuantity] = useState(1);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    if (show) {
      // Trigger animations after modal is shown
      setTimeout(() => setAnimateIn(true), 100);
    } else {
      setAnimateIn(false);
    }
  }, [show]);

  if (!product) return null;

  const {
    name = 'N/A',
    brand = 'N/A',
    description = '',
    category = 'Uncategorized',
    strain = 'N/A',
    strainDetails = '', // Added strainDetails with default empty string
    thcContent = null,
    price = 0,
    salePrice = null,
    image = '/placeholder-image.png',
    amount = 'N/A',
    tags = [],
  } = product;

  const cartItem = cartItems.find((item) => item._id === product._id);
  const currentQuantity = cartItem ? cartItem.quantity : 0;

  const handleAddToCart = () => {
    addToCart({
      ...product,
      quantity: localQuantity,
      price: salePrice || price,
      vendorName,
      logoUrl,
      primaryImage: image,
      vendorId,
    });
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered 
      size="lg"
      contentClassName="product-modal-content"
    >
      <Modal.Header closeButton className="product-modal-header">
        <div className="product-header-container">
          <div className="product-badges">
            {currentQuantity > 0 && (
              <span className="cart-badge">
                {currentQuantity} in cart
              </span>
            )}
          </div>
          <h5 className="product-brand">
            <strong>{brand}</strong>
          </h5>
        </div>
      </Modal.Header>

      <Modal.Body className="product-modal-body">
        <div className="product-content-grid">
          {/* Left Column - Image */}
          <div className={`product-image-container ${animateIn ? 'slide-in' : ''}`}>
            <img
              src={image}
              alt={name}
              className="product-image"
            />
            <span className="product-category-badge">
              {category}
            </span>
            {amount && (
              <span className="product-amount">
                {amount}
              </span>
            )}
          </div>

          {/* Right Column - Details */}
          <div className={`product-details-container ${animateIn ? 'fade-in' : ''}`}>
            {/* Tags Section */}
            {tags && tags.length > 0 && (
              <div className="product-tags">
                {tags.map((tag, index) => {
                  let tagClass = 'tag-default';
                  if (tag === 'Staff Pick') tagClass = 'tag-staff-pick';
                  else if (tag === 'High THC') tagClass = 'tag-high-thc';
                  else if (tag === 'Low THC') tagClass = 'tag-low-thc';
                  
                  return (
                    <span key={index} className={`product-tag ${tagClass}`}>
                      {tag}
                    </span>
                  );
                })}
              </div>
            )}

            <h4 className="product-name">{name}</h4>
            
            {/* Product Info Chart */}
            <div className="product-info-chart">
              <div className="info-chart-item">
                <div className="info-label">Strain</div>
                <div className="info-value">{strain}</div>
              </div>
              
              {thcContent && (
                <div className="info-chart-item">
                  <div className="info-label">THC</div>
                  <div className="info-value">{thcContent}%</div>
                </div>
              )}
              
              {/* Add strainDetails as a full-width item if it exists */}
              {strainDetails && (
                <div className="info-chart-item" style={{ gridColumn: '1 / span 2' }}>
                  <div className="info-label">Strain Details</div>
                  <div className="info-value strain-details">{strainDetails}</div>
                </div>
              )}
            </div>

            {/* Product Description */}
            <p className="product-description">
              {description || ''}
            </p>

            <div className="product-purchase-container">
              <div className="product-price">
                {salePrice ? (
                  <>
                    <span className="sale-price">${salePrice.toFixed(2)}</span>
                    <span className="original-price">${price.toFixed(2)}</span>
                  </>
                ) : (
                  <span className="regular-price">${price.toFixed(2)}</span>
                )}
              </div>

              <Button
                onClick={handleAddToCart}
                className="add-to-cart-button"
              >
                Add to Cart
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductDetails;